import Axios from 'axios';
import Env from '@/plugins/protokol/lib/Env'
import { attachApiLogger } from '@/shared/apiLogger'

const http = Axios.create({
  baseURL: Env.get("HOST") + "/ratchet",
  timeout: 15000
});


http.defaults.withCredentials = true
http.interceptors.request.use(function(config) {
  config.headers["X-Project-Uuid"] = localStorage.getItem("current_project_uuid")
  config.headers["X-Workspace-Uuid"] = localStorage.getItem("current_workspace_uuid")
  config.headers["X-Project-Env"] = localStorage.getItem("current_env")
  
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 429) {
      // Rate limit error - show toast notification only once
      if (window.vm && window.vm.$bvToast && !window._rateLimitToastShown) {
        window._rateLimitToastShown = true;
        window.vm.$bvToast.toast(window.vm.$t('rateLimitExceeded'), {
          title: window.vm.$t('warning'),
          variant: 'warning',
          solid: true,
          autoHideDelay: 5000
        });
        // Reset flag after toast auto-hides
        setTimeout(() => {
          window._rateLimitToastShown = false;
        }, 5000);
      }
    }
    if (error.response && error.response.status === 403) {
      const message = (error.response.data && error.response.data.message) || window.vm.$t('forbiddenError');
      if (window.vm && window.vm.$bvToast) {
        window.vm.$bvToast.toast(message, {
          title: window.vm.$t('error'),
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000
        });
      }
    }
    return Promise.reject(error);
  }
);

attachApiLogger(http, 'Ratchet')

export default http